import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaRe230 } from '~/endpoints/ApiTaRe230'
import { ApiTaRe270 } from '~/endpoints/ApiTaRe270'
import compareSubjectOrder from '~/utils/subjects'

// State types
interface LearningAssessmentSchool {
  placementTestReport: {
    memNum: string
    testNameDisp: string
    testResultList: {
      subjectCode: string
      answerId: string
      subjectScore: string
      subjectAverage: string
      subjectbias: string
      subjectGauge: {
        questionNo: number
        basicsScoreRate: string
        practicalScoreRate: string
      }[]
    }[]
  }
}
const getEmptyLearningAssessmentSchool = (): LearningAssessmentSchool => ({
  placementTestReport: {
    memNum: '',
    testNameDisp: '',
    testResultList: [],
  },
})

interface PdfUrlInfo {
  choiceSchoolDetermineListUrl: string
}
const getEmptyPdfUrlInfo = (): PdfUrlInfo => ({
  choiceSchoolDetermineListUrl: '',
})

// State action parameter
interface ActionParams {
  grade: number
  fiscalYear: number
  testMonth: number
  testCount: number
  courseId: string
}
type pdfurlhikisu = {
  grade: number
  fiscalYear: number
  testMonth: number
  testCount: number
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/DetermineSchool',
})
export default class DetermineSchool extends VuexModule {
  // State
  private seiseki_ = getEmptyLearningAssessmentSchool()

  private pdfurl_ = getEmptyPdfUrlInfo()

  // Getter:seisekisougou
  get learningSchool(): LearningAssessmentSchool {
    return this.seiseki_
  }

  // Getter:getPdfUrl
  get getPdfUrl(): PdfUrlInfo {
    return this.pdfurl_
  }

  @Mutation
  updateSeiseki(value: LearningAssessmentSchool) {
    this.seiseki_ = value
  }

  @Mutation
  updatePdfUrl(value: PdfUrlInfo) {
    this.pdfurl_ = value
  }

  @Action
  clear() {
    this.context.commit('updateSeiseki', getEmptyLearningAssessmentSchool())
    this.context.commit('updatePdfUrl', getEmptyPdfUrlInfo())
  }

  @Action
  async getSeiseki(param: ActionParams) {
    logger.trace('in:getSeiseki')
    const api = new ApiTaRe230.Api()
    const request: ApiTaRe230.Get.Request = {
      query: {
        fiscalYear: param.fiscalYear,
        testMonth: param.testMonth,
        grade: param.grade,
        courseId: param.courseId,
      },
    }
    const result = await api.get<LearningAssessmentSchool | null>(
      request,
      (data, _) => {
        return {
          placementTestReport: {
            ...data.placementTestReport,
            // testResultListは表示順でソートできるようにstoreの時点で調整する
            testResultList: (data.placementTestReport.testResultList || [])
              .sort((a, b) => {
                return compareSubjectOrder(a.subjectCode, b.subjectCode)
              })
              .filter(item => {
                // NOTE: dropするものがあればここで実施する
                if (item.subjectCode === 'S3J') {
                  return false
                }
                return true
              }),
          },
        }
      },
      // Error
      (data, _) => {
        logger.error(data)

        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateSeiseki', result)
  }

  @Action
  async getpdf(param: pdfurlhikisu) {
    logger.trace('in: getpdf')
    const api = new ApiTaRe270.Api()

    const result = await api.get<PdfUrlInfo | null>(
      {
        query: {
          grade: param.grade,
          fiscalYear: param.fiscalYear,
          testMonth: param.testMonth,
          testCount: param.testCount,
        },
      },
      (data, _) => {
        return { choiceSchoolDetermineListUrl: data.choiceSchoolDetermineListUrl }
      },
      (data, status) => {
        logger.error(status, data)

        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updatePdfUrl', result)
  }
}
